import { FC } from 'react';

export const CentrePage: FC = ({ children }) => (
  <div className="centre-page">{children}</div>
);
